import { Chart, ChartCategoryAxis, ChartCategoryAxisItem, ChartLegend, ChartSeries, ChartSeriesItem, ChartTitle } from '@progress/kendo-react-charts';
import { useApiTrigger } from '../../hooks/useApiTrigger';
import { forwardRef, useImperativeHandle } from 'react';

const StackedColumnChart = forwardRef(({ data, filters, returnData }, ref) => {
    const { dto } = useApiTrigger(data, filters);

    const getData = () => {
        const fileName = data.accion || 'Reporte_Grafica';
        returnData(dto, fileName);
    };

    useImperativeHandle(ref, () => ({
        exportChartData: getData,
    }));

    return (
        <Chart style={{ width: "100%", height: "100%" }}>
            <ChartTitle text={data.accion} />
            <ChartLegend position="top" orientation="horizontal" />
            <ChartCategoryAxis>
                <ChartCategoryAxisItem categories={[...new Set(dto.map(item => item.category))]} />
            </ChartCategoryAxis>

            <ChartSeries>
                {dto && dto.map((item, index) => (
                    <ChartSeriesItem
                        key={index}
                        type="column"
                        name={item.name}
                        data={item.data}
                        stack={{ group: item.stackGroup }}
                        tooltip={{ visible: true }}
                        labels={{
                            visible: true,
                            format: "{0}",
                            position: "outsideEnd"
                        }}
                    />
                ))}
            </ChartSeries>
        </Chart>
    );
})
export default StackedColumnChart;